import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const SlackIcon: FC<IconProps> = ({
  preserveColor = false,
  ...props
}) => (
  <BaseIcon {...props} customFill={preserveColor}>
    <g clipPath="url(#slack-a)">
      <mask
        id="slack-b"
        width="22"
        height="22"
        x="5"
        y="5"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'luminance' }}
      >
        <path fill="#fff" d="M27 5H5v22h22V5Z" />
      </mask>
      <g mask="url(#slack-b)">
        <path
          fill="#E01E5A"
          d="M9.636 18.852a2.3 2.3 0 0 1-2.302 2.302 2.31 2.31 0 0 1-2.31-2.302 2.304 2.304 0 0 1 2.302-2.303h2.302v2.303h.008Zm1.148 0a2.3 2.3 0 0 1 2.302-2.303 2.304 2.304 0 0 1 2.303 2.303v5.759a2.3 2.3 0 0 1-2.303 2.302 2.3 2.3 0 0 1-2.302-2.302v-5.76Z"
        />
        <path
          fill="#36C5F0"
          d="M13.093 9.59a2.3 2.3 0 0 1-2.302-2.302 2.304 2.304 0 0 1 2.302-2.302 2.304 2.304 0 0 1 2.303 2.302V9.59h-2.303Zm.001 1.168a2.3 2.3 0 0 1 2.303 2.303 2.304 2.304 0 0 1-2.303 2.302H7.312A2.3 2.3 0 0 1 5.01 13.06a2.304 2.304 0 0 1 2.302-2.302h5.782Z"
        />
        <path
          fill="#2EB67D"
          d="M22.328 13.06a2.3 2.3 0 0 1 2.302-2.302 2.304 2.304 0 0 1 2.303 2.303 2.304 2.304 0 0 1-2.303 2.302h-2.302v-2.302Zm-1.148.004a2.3 2.3 0 0 1-2.303 2.302 2.304 2.304 0 0 1-2.303-2.302V7.29a2.3 2.3 0 0 1 2.303-2.303 2.3 2.3 0 0 1 2.302 2.303v5.774Z"
        />
        <path
          fill="#ECB22E"
          d="M18.867 22.308a2.3 2.3 0 0 1 2.302 2.302 2.304 2.304 0 0 1-2.302 2.302 2.304 2.304 0 0 1-2.303-2.302v-2.302h2.303Zm0-1.154a2.3 2.3 0 0 1-2.302-2.302 2.304 2.304 0 0 1 2.302-2.303h5.782a2.3 2.3 0 0 1 2.303 2.303 2.304 2.304 0 0 1-2.303 2.302h-5.782Z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="slack-a">
        <path fill="#fff" d="M5 5h22v22H5z" />
      </clipPath>
    </defs>
  </BaseIcon>
);
